import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Language from './language';
import translationEN from './i18n/en.json';
import translationFR from './i18n/fr.json';

const defaultLanguage = Language.FR;

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    resources,
    lng: navigator.language,
    fallbackLng: defaultLanguage,

    keySeparator: '.', // to support nested translations
  });

// Custom formats used in translations as {{value, <name>}}
const formats: Record<string, [string, Intl.NumberFormatOptions]> = {
  'currency-fr': ['fr-FR', { style: 'currency', currency: 'EUR' }],
  'currencyNoCents-fr': ['fr-FR', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0,
  }],
  'currency-en': ['en-US', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0,
  }],
  'currencyNoCents-en': ['en-US', { style: 'currency', currency: 'EUR' }],
  'number-fr': ['fr-FR', {}],
  'number-en': ['en-US', {}],
};

Object.entries(formats).forEach(([name, [locale, options]]) => {
  i18n.services.formatter?.add(name, (value) => new Intl.NumberFormat(locale, options).format(value));
});

export default i18n;
